import { CDN } from '../cdn/cdn'

const isCacheAvilable = CDN.getCdnUrl().includes('green') || CDN.getCdnUrl().includes('localhost')

// const SportsModeServiceRepository = isCacheAvilable
//     ? (await import('./api-cache.constants.js')).default
//     : (await import('./api-no-cache.constants.js')).default

// export { SportsModeServiceRepository }

import API_NO_CACHE from './api-no-cache.constants.js'
import API from './api-cache.constants.js'
export const SportsModeServiceRepository = isCacheAvilable ? API : API_NO_CACHE
